import { FutManagerApi } from '@futmanager/api-sdk'
import notifications from '@kyvg/vue3-notification'
import { createHead } from '@unhead/vue/client'
import { installCharts, installI18n, installMaska, installModal, installPinia, installTable, router } from '~/libs'
import App from './App.vue'

import '@unocss/reset/tailwind.css'
import 'overlayscrollbars/overlayscrollbars.css'
import 'vue3-easy-data-table/dist/style.css'
import 'vue-final-modal/style.css'
import '@vuepic/vue-datepicker/dist/main.css'
import '~/assets/scss/index.scss'
import 'virtual:uno.css'

const ACCESS_TOKEN_KEY = 'fmtoken'
const REFRESH_TOKEN_KEY = 'fmrefresh'
const EXPIRES_AT_KEY = 'fmexpires_at'

function clearAuthStorage() {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
  localStorage.removeItem(REFRESH_TOKEN_KEY)
  localStorage.removeItem(EXPIRES_AT_KEY)
  localStorage.removeItem('user')
}

FutManagerApi.configure({
  adminUrl: import.meta.env.VITE_ADMIN_API_URL,
  authRefresh: {
    getRefreshToken: () => localStorage.getItem(REFRESH_TOKEN_KEY),
    onRefreshFailed: () => {
      clearAuthStorage()
      FutManagerApi.removeAuthToken()
      if (window.location.pathname !== '/')
        window.location.assign('/')
    },
    onTokensRefreshed: (tokens) => {
      localStorage.setItem(ACCESS_TOKEN_KEY, tokens.token)
      localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refresh_token)
      localStorage.setItem(
        EXPIRES_AT_KEY,
        String(Date.now() + tokens.expires_in * 1000),
      )
      if (tokens.user)
        localStorage.setItem('user', JSON.stringify(tokens.user))
    },
  },
  url: import.meta.env.VITE_API_URL,
})

const existingToken = localStorage.getItem(ACCESS_TOKEN_KEY)
if (existingToken) {
  FutManagerApi.setAuthToken(existingToken)
}

const app = createApp(App)

installPinia(app)
installI18n(app)
installCharts(app)
installTable(app)
installModal(app)
installMaska(app)
app.use(createHead())

app.use(router)
app.use(notifications)
app.mount('#app')
